import React from "react";
import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";

export default function NotFoundPage() {
  return (
    <>
      <PageHero eyebrow="Erreur 404" title="Page" italicWord="introuvable" subtitle="La page que vous cherchez n'existe pas ou a été déplacée." crumb="404" />
      <section className="section-padding bg-white">
        <div className="container-edge text-center">
          <Link to="/" className="btn-red" data-testid="not-found-home-cta">Retour à l'accueil</Link>
        </div>
      </section>
    </>
  );
}
